import React from 'react';

const Title = () => {
    return (
        <div className={Title}>
            <h1>Image Bucket</h1>
            <h2>Upload your pictures in the bucket</h2>
            
        </div>
    ) 
}

export default Title;